import { RadioButton } from 'components/atoms/RadioButton.tsx';
import { localize } from 'i18n/localize';
import { Pill } from 'components/atoms/Pill.tsx';
import { cn } from 'utils/cn';
import type { WatchdogNotificationInterval } from 'service/watchdog/model.ts';

export type Props = {
	onSubmit: (event: Event) => void;
	forceDisabled?: boolean;
	values: { notificationInterval: WatchdogNotificationInterval; useSeznamBar: boolean };
	isEdit?: boolean;
	onUseSeznamBarChange: (value: boolean) => void;
	onNotificationIntervalChange: (value: WatchdogNotificationInterval) => void;
};

const $t = localize();

export function WatchdogForm({ onSubmit, values, forceDisabled, isEdit, onNotificationIntervalChange }: Props) {
	const { notificationInterval } = values;

	return (
		<div>
			<span class="font-bold text-sm text-dark-blue-50 mb-2 block">{$t.watchdog.notification.label}</span>
			<div class="mb-2">
				<RadioButton
					value="hourly"
					name="notification_interval_change"
					inputProps={{
						onInput: () => {
							onNotificationIntervalChange('hourly');
						},
						checked: notificationInterval === 'hourly',
					}}
				>
					<span className={cn({ 'text-red font-bold': notificationInterval === 'hourly' })}>
						{$t.watchdog.notification.hourly}
					</span>
					<span class="text-dark-blue-50"> ({$t.watchdog.notification.hourlyDescription})</span>
				</RadioButton>
			</div>
			<div class="mb-2">
				<RadioButton
					value="daily"
					name="notification_interval_change"
					inputProps={{
						onInput: () => {
							onNotificationIntervalChange('daily');
						},
						checked: notificationInterval === 'daily',
					}}
				>
					<span className={cn({ 'text-red font-bold': notificationInterval === 'daily' })}>
						{$t.watchdog.notification.daily}
					</span>
					<span class="text-dark-blue-50"> ({$t.watchdog.notification.dailyDescription})</span>
				</RadioButton>
			</div>
			<div class="mb-2">
				<RadioButton
					value="never"
					name="notification_interval_change"
					inputProps={{
						onInput: () => {
							onNotificationIntervalChange('never');
						},
						checked: notificationInterval === 'never',
					}}
				>
					<span className={cn({ 'text-red font-bold': notificationInterval === 'never' })}>
						{$t.watchdog.notification.never}
					</span>
					<span class="text-dark-blue-50"> ({$t.watchdog.notification.neverDescription})</span>
				</RadioButton>
			</div>
			{/* Todo: Prepared for the future. Once BE implements it just uncomment this and retrieve the props */}
			{/*<div class="relative mb-2">*/}
			{/*	<Checkbox*/}
			{/*		inputProps={{ checked: useSeznamBar }}*/}
			{/*		onInput={(event: InputEvent) => {*/}
			{/*			onUseSeznamBarChange((event.target as HTMLInputElement).checked);*/}
			{/*		}}*/}
			{/*	>*/}
			{/*		<span className={cn('pl-2', { 'text-red font-bold': useSeznamBar })}>*/}
			{/*			{$t.watchdog.notification.useSeznamBar}*/}
			{/*		</span>*/}
			{/*	</Checkbox>*/}
			{/*</div>*/}
			<div>
				<Pill
					as="button"
					type="submit"
					pillType="primary"
					className="w-full py-3 mt-5 text-base font-bold"
					isActive={forceDisabled}
					onClick={onSubmit}
				>
					{isEdit ? $t.watchdog.buttonEdit : $t.watchdog.buttonCreate}
				</Pill>
			</div>
		</div>
	);
}
